import React from "react";
import NotifierContainer from "./notifier/NotifierContainer";

export default function Lobby(props) {
  return (
    <React.Fragment>
      <NotifierContainer />
      {props.children}
    </React.Fragment>
  );
}
